import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@instructure/ui-buttons';
import { IconArrowOpenStartSolid, IconArrowOpenEndSolid } from '@instructure/ui-icons';
import { themeable } from '@instructure/ui-themeable';
var styles = {
  componentId: 'dfDow',
  template: function template(theme) {
    return "\n\n.dfDow_bGBk{align-items:center;box-sizing:border-box;color:".concat(theme.color || 'inherit', ";display:flex;font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";justify-content:space-between;padding:0 0.125rem}\n\n.dfDow_eCxz{font-size:").concat(theme.buttonIconSize || 'inherit', "}");
  },
  'root': 'dfDow_bGBk',
  'arrowIcon': 'dfDow_eCxz'
};
import theme from './theme';
/**
---
parent: DatePicker
---
**/

var DatePickerPagination = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(DatePickerPagination, _Component);

  var _super = _createSuper(DatePickerPagination);

  function DatePickerPagination() {
    var _this;

    _classCallCheck(this, DatePickerPagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handlePrevClick = function (e) {
      _this.props.onPrev(e);
    };

    _this.handleNextClick = function (e) {
      _this.props.onNext(e);
    };

    return _this;
  }

  _createClass(DatePickerPagination, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.root
      }, /*#__PURE__*/React.createElement(IconButton, {
        withBackground: false,
        withBorder: false,
        onClick: this.handlePrevClick,
        renderIcon: /*#__PURE__*/React.createElement(IconArrowOpenStartSolid, {
          className: styles.arrowIcon
        }),
        screenReaderLabel: this.props.previousLabel
      }), this.props.children, /*#__PURE__*/React.createElement(IconButton, {
        withBackground: false,
        withBorder: false,
        onClick: this.handleNextClick,
        renderIcon: /*#__PURE__*/React.createElement(IconArrowOpenEndSolid, {
          className: styles.arrowIcon
        }),
        screenReaderLabel: this.props.nextLabel
      }));
    }
  }]);

  DatePickerPagination.displayName = "DatePickerPagination";
  return DatePickerPagination;
}(Component), _class2.propTypes = {
  previousLabel: PropTypes.string.isRequired,
  nextLabel: PropTypes.string.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  children: PropTypes.node
}, _class2.defaultProps = {
  children: null
}, _temp)) || _class);
export default DatePickerPagination;
export { DatePickerPagination };